export default {"src":"/_next/static/media/window-bay-and-bow.28cc659e.svg","height":1000,"width":1000};